define('GameDayCore/GDModel/ValueObjects/Linescore/LinescoreInnings',['require','exports','module','../ValueObjectFactory','./LinescoreItem'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory'),
		scheduledInnings = "";

	VO.create(LinescoreInnings);

	function LinescoreInnings($data) {
		var vo = VO.ensureVO(this, LinescoreInnings),
			data = $data,
			LinescoreItem = require('./LinescoreItem'),
			inningData,
			gameStatus = data.status_ind || data.status,
			innArr = [],
		    inns = [].concat($data.linescore || $data.inning_line_score),
		    innsCount = inns.length;

		scheduledInnings = data.scheduled_innings || scheduledInnings;
		var l = Math.max(parseInt(scheduledInnings), innsCount);

		for (var i = 0; i < l; i++) {
		    inningData = inns[i];
		    innArr.push(new LinescoreItem(inningData, i + 1, data.status_ind || data.status));
		}
		inningData = innArr[innsCount - 1];

		inningData.away_active = data.inning_state === "Top" && gameStatus[0] !== "F";
		inningData.home_active = data.inning_state === "Bottom" && gameStatus[0] !== "F";

		vo.inning = innsCount-1;
		vo.innings = innArr;
	}

	return LinescoreInnings;
});
